import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=24c58e99&scoped=true&"
import script from "./apply.vue?vue&type=script&lang=js&"
export * from "./apply.vue?vue&type=script&lang=js&"
import style0 from "./apply.vue?vue&type=style&index=0&id=24c58e99&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c58e99",
  null
  
)

export default component.exports